<template>
  <div id="NewDetail">
    <jw-navigation>
      <banner></banner>
      <div class="page-content">
        <h2 style="text-align: center;">{{news.new_title}}</h2>
        <div style="display: flex;flex-direction: row;justify-content: space-between;margin: 5px 0;background-color: #e8eaec;padding: 0 5px;">
          <div>作者：{{news.author}}</div>
          <div>发表时间：{{news.create_time}}</div>
          <div>阅读次数：{{news.read_count}}</div>
        </div>
        <div style="padding: 10px;border-bottom: solid 1px #e8eaec;margin-bottom: 10px;">
          {{news.brief}}
        </div>
        <div style="width: 100%;text-align: center;background-color: #e8eaec;padding: 5px;">
          <img :src="news.cover" style="width: 50%;height: 260px;">
        </div>
        <div style="padding: 5px;" v-html="news.content"></div>
      </div>
    </jw-navigation>
  </div>
</template>

<script>
import Banner from "@/views/web/home/components/Banner.vue";
import {getNewList} from "@/request/web/news";
export default {
  name: "NewDetail",
  // 注册组件
  components: {
    Banner
  },
  // 属性
  props: {},
  // 页面数据
  data() {
    return {
      news: {
        new_title: '',
        author: '',
        read_count: 18,
        create_time: '',
        brief: '',
        content: ''
      },
      page: {
        pageIndex: 1,
        pageSize: 1
      },
      filter: {
        new_id: ''
      }
    }
  },
  created() {
    this.filter.new_id = this.$route.params.newsId
    this.onGetNewList()
  },
  methods: {
    // 获取会员单位列表
    onGetNewList() {
      getNewList({
        ...this.page,
        filter: this.filter
      }).then(res=> {
        this.news = res.data.data.list[0]
      })
    }
  }
}
</script>

<style scoped>

</style>
